import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { PartnerEngagementConfigurationListType,PartnerEngagementCategoryListType} from "./Types";

type initialStateType = {
    fetchedPartnerEngagementConfigurationListID: number;
    partnerEngagementConfigurationList: PartnerEngagementConfigurationListType;
    partnerEngagementCategoryList: PartnerEngagementCategoryListType;
    status: {
        partnerEngagementConfigurationListLoading: boolean;
        partnerEngagementCategoryListLoading: boolean;
        addPartnerEngagementConfigurationListStatus: boolean;
        addPartnerEngagementConfigurationListMessage: string;
        updatePartnerEngagementConfigurationListStatus: boolean;
        updatePartnerEngagementConfigurationListMessage: string,
        updatePartnerEngagementConfigurationListLoading: boolean,
        deletePartnerEngagementConfigurationListStatus: boolean;
        deletePartnerEngagementConfigurationListMessage: string;
        deletePartnerEngagementConfigurationListLoading: boolean;
        addEngagementCategoryLoading: boolean;
        addEngagementCategoryStatus: boolean;
        addEngagementCategoryMessage: string;
        updateEngagementCategoryLoading: boolean;
        updateEngagementCategoryStatus: boolean;
        updateEngagementCategoryMessage: string;
        deleteEngagementCategoryLoading: boolean;
        deleteEngagementCategoryStatus: "idle" | "success" | "error";
        deleteEngagementCategoryMessage: string;
    }
}

var initialState: initialStateType = {
    fetchedPartnerEngagementConfigurationListID: 0,
    partnerEngagementConfigurationList: [],
    partnerEngagementCategoryList:[],
    status: {
        partnerEngagementConfigurationListLoading: false,
        partnerEngagementCategoryListLoading: false,
        addPartnerEngagementConfigurationListStatus: false,
        addPartnerEngagementConfigurationListMessage: "",
        updatePartnerEngagementConfigurationListStatus: false,
        updatePartnerEngagementConfigurationListMessage: "",
        updatePartnerEngagementConfigurationListLoading: false,
        deletePartnerEngagementConfigurationListStatus: false,
        deletePartnerEngagementConfigurationListMessage: "",
        deletePartnerEngagementConfigurationListLoading: false,
        addEngagementCategoryLoading: false,
        addEngagementCategoryStatus: false,
        addEngagementCategoryMessage: "",
        updateEngagementCategoryLoading: false,
        updateEngagementCategoryStatus: false,
        updateEngagementCategoryMessage: "",
        deleteEngagementCategoryLoading: false,
        deleteEngagementCategoryStatus: "idle",
        deleteEngagementCategoryMessage: "",
    }
}

const partnerEngagementConfigurationSlice = createSlice({
    name: "partner_engagementConfiguration",
    initialState: initialState,
    reducers: {
        setFetchedEngagementConfigurationID: (state, action) => {
            state.fetchedPartnerEngagementConfigurationListID = action.payload;
        },
        setPartnerEngagementConfigurationLoading: (state, action) => {
            state.status.partnerEngagementConfigurationListLoading = action.payload;
        },
        setPartnerEngagementCategoryLoading: (state, action) => {
            state.status.partnerEngagementCategoryListLoading = action.payload;
        },
        setPartnerEngagementConfigurationList: (state, action:PayloadAction<PartnerEngagementConfigurationListType>) => {
            state.partnerEngagementConfigurationList = action.payload;
        },
         setPartnerEngagementCategoryList: (state, action:PayloadAction<PartnerEngagementCategoryListType>) => {
            state.partnerEngagementCategoryList = action.payload;
        },
        setAddpartnerEngagementConfigurationStatus: (state, action) => {
            state.status.addPartnerEngagementConfigurationListStatus = action.payload;
        },
        setAddpartnerEngagementConfigurationMessage: (state, action) => {
            state.status.addPartnerEngagementConfigurationListMessage = action.payload;
        },
        setAddpartnerEngagementConfigurationLoading : (state, action) => {
            state.status.partnerEngagementConfigurationListLoading = action.payload;
        },
        setupdatepartnerEngagementConfigurationStatus: (state, action) => {
            state.status.updatePartnerEngagementConfigurationListStatus = action.payload;
        },
        setUpdatepartnerEngagementConfigurationMessage: (state, action) => {
            state.status.updatePartnerEngagementConfigurationListMessage = action.payload;
        },
        setUpdatepartnerEngagementConfigurationLoading: (state, action) => {
            state.status.updatePartnerEngagementConfigurationListLoading = action.payload;
        },
        setDeletePartnerEngagementConfigurationStatus: (state, action) => {
            state.status.deletePartnerEngagementConfigurationListStatus = action.payload;
        },
        setDeletePartnerEngagementConfigurationMessage: (state, action) => {
            state.status.deletePartnerEngagementConfigurationListMessage = action.payload;
        },
        setDeletePartnerEngagementConfigurationLoading: (state, action) => {
            state.status.deletePartnerEngagementConfigurationListLoading = action.payload;
        },
        setAddEngagementCategoryLoading: (state, action) => {
            state.status.addEngagementCategoryLoading = action.payload;
        },
        setAddEngagementCategoryStatus: (state, action) => {
            state.status.addEngagementCategoryStatus = action.payload;
        },
        setAddEngagementCategoryMessage: (state, action) => {
            state.status.addEngagementCategoryMessage = action.payload;
        },
        setUpdateEngagementCategoryLoading: (state, action) => {
            state.status.updateEngagementCategoryLoading = action.payload;
        },
        setUpdateEngagementCategoryStatus: (state, action) => {
            state.status.updateEngagementCategoryStatus = action.payload;
        },
        setUpdateEngagementCategoryMessage: (state, action) => {
            state.status.updateEngagementCategoryMessage = action.payload;
        },
        setDeleteEngagementCategoryLoading: (state, action) => {
            state.status.deleteEngagementCategoryLoading = action.payload;
        },
        setDeleteEngagementCategoryStatus: (state, action) => {
            state.status.deleteEngagementCategoryStatus = action.payload;
        },
        setDeleteEngagementCategoryMessage: (state, action) => {
            state.status.deleteEngagementCategoryMessage = action.payload;
        },
        resetDeleteEngagementCategoryStatus: (state) => {
            state.status.deleteEngagementCategoryLoading = false;
            state.status.deleteEngagementCategoryStatus = "idle";
            state.status.deleteEngagementCategoryMessage = "";
        },
        resetEngagementCategoryMutationStatus: (state) => {
            state.status.addEngagementCategoryLoading = false;
            state.status.addEngagementCategoryStatus = false;
            state.status.addEngagementCategoryMessage = "";
            state.status.updateEngagementCategoryLoading = false;
            state.status.updateEngagementCategoryStatus = false;
            state.status.updateEngagementCategoryMessage = "";
        },
    }
})

export const partnerEngagementConfigurationSliceReducer = partnerEngagementConfigurationSlice.reducer;
export const partnerEngagementConfigurationSliceAction = partnerEngagementConfigurationSlice.actions;
